import { render, staticRenderFns } from "./journeyInvoice.vue?vue&type=template&id=41cb252c&"
import script from "./journeyInvoice.vue?vue&type=script&lang=js&"
export * from "./journeyInvoice.vue?vue&type=script&lang=js&"
import style0 from "./journeyInvoice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports